import { render, staticRenderFns } from "./PostFileSelect.vue?vue&type=template&id=612d8144&scoped=true"
import script from "./PostFileSelect.vue?vue&type=script&lang=js"
export * from "./PostFileSelect.vue?vue&type=script&lang=js"
import style0 from "./PostFileSelect.vue?vue&type=style&index=0&id=612d8144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d8144",
  null
  
)

export default component.exports